import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

import Row from "../common/layout/row";
import Select from "../common/form/select";
import { adicionarPontosMilhar } from "../utils/adicionarPontosMilhar";
import Table from "../common/table/table";
import THead from "../common/table/tHead";
import Tr from "../common/table/tr";
import Th from "../common/table/th";
import TBody from "../common/table/tBody";
import Td from "../common/table/td";
import { bindActionCreators } from "redux";
import BotaoExcluir from "../common/button/botaoExcluir";
import NumberFormat from "react-number-format";
import avatarGradiosPositivo from "../assets/images/avatar_gradios_positivo.png";
import avatarGradiosNegativo from "../assets/images/avatar_gradios_negativo.png";
import { buscarTarifasSimulacaoOptante, setTarifasSimulacaoAneel } from "./diagnosticoEnergiaActions";
import Button from "../common/button/button";
import Grid from "../common/layout/grid";
import { da } from "date-fns/locale";

function RenderizarAnaliseOpcaoTarifariaOptanteAB(props) {
    const [state, setState] = useState({ tarifasApi: {}, nome_modalidade_tarifaria: "Convencional" });

    const backgroundColor = "#58c5fb";
    const color = "#08354c";
    const corValorEditado = "#008fd7";

    const qtdTotalExcedenteForaPonta = (props.situacaoAtual.lista_energia_excedente || []).reduce((acc, item) => (acc += item.quantidade_energia_excedente_fora_ponta), 0);
    const qtdTotalExcedentePonta = (props.situacaoAtual.lista_energia_excedente || []).reduce((acc, item) => (acc += item.quantidade_energia_excedente_ponta), 0);

    const tusdMaisTe = (parseFloat(props.tarifasAneelSimulacao.tarifa_energia_tusd) || 0) + (parseFloat(props.tarifasAneelSimulacao.tarifa_energia_te) || 0);

    const valorEnergiaExcedenteForaPonta = qtdTotalExcedenteForaPonta * -1 * tusdMaisTe;
    const valorEnergiaExcedentePonta = qtdTotalExcedentePonta * -1 * tusdMaisTe;

    const qtdEnergiaTotal = (parseFloat(props.dados.quantidade_energia_fora_ponta) || 0) + (parseFloat(props.dados.quantidade_energia_ponta) || 0);
    const tarifaTusd = parseFloat(props.tarifasAneelSimulacao.tarifa_energia_tusd) || 0;
    const tarifaTe = parseFloat(props.tarifasAneelSimulacao.tarifa_energia_te) || 0;
    const valorTotalEnergiaTusd = qtdEnergiaTotal * tarifaTusd;
    const valorTotalEnergiaTe = qtdEnergiaTotal * tarifaTe;

    const totalSituacaoAtual =
        (parseFloat(props.situacaoAtual.valor_energia_ponta) || 0) +
        (parseFloat(props.situacaoAtual.valor_energia_fora_ponta) || 0) +
        (parseFloat(props.situacaoAtual.valor_energia_reservado) || 0) +
        (parseFloat(props.situacaoAtual.valor_demanda_ponta) || 0) +
        (parseFloat(props.situacaoAtual.valor_demanda_fora_ponta) || 0) +
        (props.exibirUltrapassagemDemanda ? parseFloat(props.situacaoAtual.valor_ultrapassagem_demanda_fora_ponta) || 0 : 0) +
        (parseFloat(props.situacaoAtual.valor_imposto) || 0) +
        (parseFloat(props.situacaoAtual.valor_bandeira) || 0);

    const subtotal =
        valorTotalEnergiaTusd +
        valorTotalEnergiaTe +
        valorEnergiaExcedenteForaPonta +
        valorEnergiaExcedentePonta +
        (props.exibirUltrapassagemDemanda ? parseFloat(props.situacaoAtual.valor_ultrapassagem_demanda_fora_ponta) || 0 : 0) +
        (parseFloat(props.dados.valor_energia_reservado_tusd) || 0) +
        (parseFloat(props.dados.valor_energia_reservado_te) || 0);

    const totalImposto = (props.dados.aliquota_pis_pasep / 100) * subtotal + (props.dados.aliquota_cofins / 100) * subtotal + (props.dados.aliquota_icms / 100) * subtotal;

    const totalComImposto = subtotal + totalImposto;

    const percentualEconomizado = ((totalSituacaoAtual - totalComImposto) * 100) / totalSituacaoAtual;

    return (
        <div style={{ backgroundColor: "#FFF", borderRadius: 8 }}>
            <Table id={props.id} minHeight="fit-content" responsive padding={6} borderRadius={25}>
                <THead>
                    <Tr>
                        <Th colSpan={5} alignCenter maxHeight="100%" backgroundColor={backgroundColor} color="#FFF" style={{ padding: 6 }}>
                            <div className="d-flex">
                                <div style={{ flexGrow: "1" }}>Opção Faturar em B</div>
                                <div>
                                    <BotaoExcluir event={() => props.removerAnalise({ tipoAnalise: "Opção Tarifária (Optante A ou B)" })} />
                                </div>
                            </div>
                        </Th>
                    </Tr>
                </THead>

                <TBody>
                    <Tr style={{ fontWeight: "450" }}>
                        <Td backgroundColor="#ecf5fd" color={color} paddingLeft={4} colSpan={2}>
                            Tipo de mercado
                        </Td>
                        <Td width={200} alignCenter colSpan={3}>
                            {props.ucFiltrada.nome_tipo_mercado ? props.ucFiltrada.nome_tipo_mercado : " - "}
                        </Td>
                    </Tr>
                    <Tr style={{ fontWeight: "450" }}>
                        <Td backgroundColor="#ecf5fd" color={color} paddingLeft={4} colSpan={2}>
                            Grupo de Faturamento
                        </Td>
                        <Td width={200} alignCenter colSpan={3}>
                            Grupo A Faturado em B (Optante com Demanda)
                        </Td>
                    </Tr>
                    <Tr style={{ fontWeight: "450" }}>
                        <Td backgroundColor="#ecf5fd" color={color} paddingLeft={4} colSpan={2}>
                            <div className="my-3">Tarifa Aplicada ANEEL por kWh</div>
                        </Td>
                        <Td width={200} alignCenter colSpan={3}>
                            <Row>
                                <Select
                                    name="nome_subgrupo_faturamento"
                                    options={props.listaSubgrupoFaturamento
                                        .filter((item) => item.ids_grupo_faturamento.includes(3)) //Grupo A Fat em B
                                        .map((item) => ({ id: item.valor, valor: item.valor }))}
                                    label="Subgrupo de Faturamento"
                                    cols="12 12 12 12"
                                    placeholder="Subgrupo"
                                    isClearable={true}
                                    value={state.nome_subgrupo_faturamento}
                                    onChange={(data) => {
                                        setState({
                                            ...state,
                                            nome_subgrupo_faturamento: data,
                                        });
                                    }}
                                />
                                <Select
                                    name="nome_modalidade_tarifaria"
                                    // options={props.listaModalidadeTarifaria.map((item) => ({ id: item.valor, valor: item.valor }))}
                                    options={[{ id: "Convencional", valor: "Convencional" }]}
                                    label="Modalidade Tarifária"
                                    cols="12 12 12 12"
                                    placeholder="Modalidade"
                                    isClearable={true}
                                    value={state.nome_modalidade_tarifaria}
                                    onChange={(data) => {
                                        setState({
                                            ...state,
                                            nome_modalidade_tarifaria: data,
                                        });
                                    }}
                                />
                                <Grid cols="12 12 12 12" style={{ display: "flex", alignItems: "center" }}>
                                    <Button
                                        title="Buscar Tarifas ANEEL"
                                        disabled={!state.nome_subgrupo_faturamento || !state.nome_modalidade_tarifaria}
                                        text={"Buscar"}
                                        type={"primary"}
                                        solid={true}
                                        style={{ margin: 0, padding: 8 }}
                                        event={() => {
                                            props.buscarTarifasSimulacaoOptante(state, (tarifasApi) => {
                                                if (!tarifasApi) return;
                                                setState({ ...state, tarifasApi: { ...tarifasApi } });
                                            });
                                        }}
                                    />
                                </Grid>
                            </Row>
                            <Row>
                                <Grid cols="12 12 4 4" style={{ marginTop: 5 }}>
                                    <div>Vigência</div>
                                    {props.tarifasAneelSimulacao.data_inicio_vigencia_tarifa_energia && props.tarifasAneelSimulacao.data_fim_vigencia_tarifa_energia ? (
                                        <div style={{ fontSize: "0.85rem", marginTop: 5 }}>
                                            {props.tarifasAneelSimulacao.data_inicio_vigencia_tarifa_energia +
                                                " à " +
                                                props.tarifasAneelSimulacao.data_fim_vigencia_tarifa_energia || " - "}
                                        </div>
                                    ) : (
                                        " - "
                                    )}
                                </Grid>
                                <Grid cols="12 12 4 4" style={{ marginTop: 10 }}>
                                    <div>TUSD</div>
                                    <div>
                                        <NumberFormat
                                            className="form-control"
                                            disabled={false}
                                            placeholder={"0,000000"}
                                            decimalSeparator={","}
                                            decimalScale={6}
                                            fixedDecimalScale={6}
                                            value={String(props.tarifasAneelSimulacao.tarifa_energia_tusd || 0).replace(".", ",")}
                                            onValueChange={(values) => {
                                                const valor = values.floatValue || 0;
                                                props.setTarifasSimulacaoAneel({
                                                    ...props.tarifasAneelSimulacao,
                                                    tarifa_energia_tusd: valor,
                                                    data_inicio_vigencia_tarifa_energia:
                                                        valor !== state.tarifasApi.tarifa_energia_tusd ? null : state.tarifasApi.data_inicio_vigencia_tarifa_energia,
                                                    data_fim_vigencia_tarifa_energia:
                                                        valor !== state.tarifasApi.tarifa_energia_tusd ? null : state.tarifasApi.data_fim_vigencia_tarifa_energia,
                                                });
                                            }}
                                        />
                                    </div>
                                </Grid>
                                <Grid cols="12 12 4 4" style={{ marginTop: 10 }}>
                                    <div>TE</div>
                                    <div>
                                        <NumberFormat
                                            className="form-control"
                                            disabled={false}
                                            placeholder={"0,000000"}
                                            decimalSeparator={","}
                                            decimalScale={6}
                                            fixedDecimalScale={6}
                                            value={String(props.tarifasAneelSimulacao.tarifa_energia_te || 0).replace(".", ",")}
                                            onValueChange={(values) => {
                                                const valor = values.floatValue || 0;
                                                props.setTarifasSimulacaoAneel({
                                                    ...props.tarifasAneelSimulacao,
                                                    tarifa_energia_te: valor,
                                                    data_inicio_vigencia_tarifa_energia:
                                                        valor !== state.tarifasApi.tarifa_energia_te ? null : state.tarifasApi.data_inicio_vigencia_tarifa_energia,
                                                    data_fim_vigencia_tarifa_energia:
                                                        valor !== state.tarifasApi.tarifa_energia_te ? null : state.tarifasApi.data_fim_vigencia_tarifa_energia,
                                                });
                                            }}
                                        />
                                    </div>
                                </Grid>
                            </Row>
                        </Td>
                    </Tr>
                    <Tr style={{ fontWeight: "450" }}>
                        <Td backgroundColor={backgroundColor} color="#ecf5fd" paddingLeft={4} colSpan={2}>
                            Descrição
                        </Td>
                        <Td backgroundColor={backgroundColor} color="#ecf5fd" width={200} alignCenter>
                            Quantidade
                        </Td>
                        <Td backgroundColor={backgroundColor} color="#ecf5fd" width={100} alignCenter>
                            Tarifa
                        </Td>
                        <Td backgroundColor={backgroundColor} color="#ecf5fd" width={200} alignCenter>
                            R$
                        </Td>
                    </Tr>

                    <Tr style={{ fontWeight: "450" }}>
                        <Td backgroundColor="#ecf5fd" color={color} paddingLeft={4} rowSpan={2}>
                            Energia Total
                        </Td>
                        <Td backgroundColor="#ecf5fd" color={color} paddingLeft={4}>
                            TUSD
                        </Td>
                        <Td width={200} alignCenter>
                            {qtdEnergiaTotal ? adicionarPontosMilhar(qtdEnergiaTotal, 2) + " kWh" : " - "}
                        </Td>
                        <Td width={100} alignCenter>
                            {tarifaTusd ? "R$ " + adicionarPontosMilhar(tarifaTusd, 6) : " - "}
                        </Td>
                        <Td width={200} alignCenter>
                            {valorTotalEnergiaTusd ? "R$ " + adicionarPontosMilhar(valorTotalEnergiaTusd, 6) : " - "}
                        </Td>
                    </Tr>
                    <Tr style={{ fontWeight: "450" }}>
                        <Td backgroundColor="#ecf5fd" color={color} paddingLeft={4}>
                            TE
                        </Td>
                        <Td width={200} alignCenter>
                            {qtdEnergiaTotal ? adicionarPontosMilhar(qtdEnergiaTotal, 2) + " kWh" : " - "}
                        </Td>
                        <Td width={100} alignCenter>
                            {tarifaTe ? "R$ " + adicionarPontosMilhar(tarifaTe, 6) : " - "}
                        </Td>
                        <Td width={200} alignCenter>
                            {valorTotalEnergiaTe ? "R$ " + adicionarPontosMilhar(valorTotalEnergiaTe, 6) : " - "}
                        </Td>
                    </Tr>
                    {!!props.ucFiltrada.irrigante && (
                        <>
                            <Tr style={{ fontWeight: "450" }}>
                                <Td backgroundColor="#ecf5fd" color={color} paddingLeft={4} rowSpan={2}>
                                    Energia Reservado
                                </Td>
                                <Td backgroundColor="#ecf5fd" color={color} paddingLeft={4}>
                                    TUSD
                                </Td>
                                <Td width={200} alignCenter>
                                    {props.dados.quantidade_energia_reservado ? adicionarPontosMilhar(props.dados.quantidade_energia_reservado, 2) + " kWh" : " - "}
                                </Td>
                                <Td width={100} alignCenter>
                                    {props.dados.valor_energia_reservado_tusd && props.dados.quantidade_energia_reservado
                                        ? "R$ " + adicionarPontosMilhar(props.dados.valor_energia_reservado_tusd / props.dados.quantidade_energia_reservado, 6)
                                        : " - "}
                                </Td>
                                <Td width={200} alignCenter>
                                    {props.dados.valor_energia_reservado_tusd ? "R$ " + adicionarPontosMilhar(props.dados.valor_energia_reservado_tusd, 6) : " - "}
                                </Td>
                            </Tr>
                            <Tr style={{ fontWeight: "450" }}>
                                <Td backgroundColor="#ecf5fd" color={color} paddingLeft={4}>
                                    TE
                                </Td>
                                <Td width={200} alignCenter>
                                    {props.dados.quantidade_energia_reservado ? adicionarPontosMilhar(props.dados.quantidade_energia_reservado, 2) + " kWh" : " - "}
                                </Td>
                                <Td width={100} alignCenter>
                                    {props.dados.valor_energia_reservado_te && props.dados.quantidade_energia_reservado
                                        ? "R$ " + adicionarPontosMilhar(props.dados.valor_energia_reservado_te / props.dados.quantidade_energia_reservado, 6)
                                        : " - "}
                                </Td>
                                <Td width={200} alignCenter>
                                    {props.dados.valor_energia_reservado_te ? "R$ " + adicionarPontosMilhar(props.dados.valor_energia_reservado_te, 6) : " - "}
                                </Td>
                            </Tr>
                        </>
                    )}
                    {!!(props.ucFiltrada.geracao || props.ucFiltrada.id_unidade_geradora) && (
                        <>
                            <Tr style={{ fontWeight: "450" }}>
                                <Td backgroundColor="#ecf5fd" color={color} paddingLeft={4} colSpan={2}>
                                    Energia Excedente/Injetada Fora Ponta
                                </Td>
                                <Td width={200} alignCenter>
                                    {qtdTotalExcedenteForaPonta ? adicionarPontosMilhar(qtdTotalExcedenteForaPonta, 2) + " kWh" : " - "}
                                </Td>
                                <Td width={100} alignCenter>
                                    {tusdMaisTe ? "R$ " + adicionarPontosMilhar(tusdMaisTe, 6) : " - "}
                                </Td>
                                <Td width={200} alignCenter>
                                    {valorEnergiaExcedenteForaPonta ? "R$ " + adicionarPontosMilhar(valorEnergiaExcedenteForaPonta, 6) : " - "}
                                </Td>
                            </Tr>
                            {/* <Tr style={{ fontWeight: "450" }}>
                                <Td backgroundColor="#ecf5fd" color={color} paddingLeft={4} colSpan={2}>
                                    Energia Excedente/Injetada Ponta
                                </Td>
                                <Td width={200} alignCenter>
                                    {qtdTotalExcedentePonta ? adicionarPontosMilhar(qtdTotalExcedentePonta, 2) + " kWh" : " - "}
                                </Td>
                                <Td width={200} alignCenter>
                                    {valorEnergiaExcedentePonta ? "R$ " + adicionarPontosMilhar(valorEnergiaExcedentePonta, 6) : " - "}
                                </Td>
                            </Tr> */}
                        </>
                    )}
                    <Tr style={{ fontWeight: "450" }}>
                        <Td backgroundColor="#ecf5fd" color={color} paddingLeft={4} colSpan={2}>
                            Demanda Fora Ponta
                        </Td>
                        <Td width={200} alignCenter>
                            {props.dados.quantidade_demanda_fora_ponta ? adicionarPontosMilhar(props.dados.quantidade_demanda_fora_ponta, 2) + " kW" : " - "}
                        </Td>
                        <Td width={100} alignCenter>
                            {"N/A"}
                        </Td>
                        <Td width={200} alignCenter>
                            {"N/A"}
                        </Td>
                    </Tr>
                    {props.exibirUltrapassagemDemanda && (
                        <Tr style={{ fontWeight: "450" }}>
                            <Td backgroundColor="#ecf5fd" color={color} paddingLeft={4} colSpan={2}>
                                Ultrapassagem de Demanda Fora Ponta
                            </Td>
                            <Td width={200} alignCenter>
                                {props.dados.quantidade_ultrapassagem_demanda_fora_ponta
                                    ? adicionarPontosMilhar(props.dados.quantidade_ultrapassagem_demanda_fora_ponta, 2) + " kW"
                                    : " - "}
                            </Td>
                            <Td width={100} alignCenter>
                                -
                            </Td>
                            <Td width={200} alignCenter>
                                {props.dados.valor_ultrapassagem_demanda_fora_ponta
                                    ? props.dados.id_tipo_energia_mercado_livre == 1 && props.dados.percentual_mercado_livre
                                        ? "R$ " +
                                          adicionarPontosMilhar(
                                              props.dados.valor_ultrapassagem_demanda_fora_ponta -
                                                  (props.dados.percentual_mercado_livre / 100) * props.dados.valor_ultrapassagem_demanda_fora_ponta,
                                              6
                                          )
                                        : "R$ " + adicionarPontosMilhar(props.dados.valor_ultrapassagem_demanda_fora_ponta, 6)
                                    : " - "}
                            </Td>
                        </Tr>
                    )}
                    <Tr style={{ fontWeight: "450" }}>
                        <Td
                            backgroundColor="#ecf5fd"
                            color={color}
                            paddingLeft={4}
                            colSpan={2}
                            title={`Alíquota de Imposto Calculada: ${adicionarPontosMilhar(props.dados.aliquota_calculada)}% = R$ ${adicionarPontosMilhar(
                                (props.dados.aliquota_calculada / 100) * subtotal
                            )}`}
                        >
                            Impostos (Base de Cálculo: R$ {adicionarPontosMilhar(subtotal)})
                        </Td>
                        <Td width={200} alignCenter>
                            N/A
                        </Td>
                        <Td width={100} alignCenter>
                            N/A
                        </Td>
                        <Td width={200} alignCenter>
                            R$ {adicionarPontosMilhar(totalImposto)}
                        </Td>
                    </Tr>
                    <Tr style={{ fontWeight: "450", backgroundColor: percentualEconomizado > 0 ? "#09cf6c" : "#cb0f31" }}>
                        <Td color="#ecf5fd" paddingLeft={4} colSpan={2}>
                            Total
                        </Td>
                        <Td color="#ecf5fd" width={200} alignCenter>
                            =
                        </Td>
                        <Td color="#ecf5fd" width={200} alignCenter colSpan={2}>
                            <div>{"R$ " + adicionarPontosMilhar(totalComImposto) + ` (${adicionarPontosMilhar(Math.abs(percentualEconomizado || 0))}%)`}</div>
                        </Td>
                    </Tr>
                    <Tr>
                        <Td color="#ecf5fd" paddingLeft={4} colSpan={5}>
                            {percentualEconomizado && (
                                <div style={{ filter: "brightness(1.1)" }}>
                                    <img
                                        src={percentualEconomizado > 0 ? avatarGradiosPositivo : avatarGradiosNegativo}
                                        alt={percentualEconomizado > 0 ? "Economizou" : "Não economizou"}
                                    />
                                </div>
                            )}
                        </Td>
                    </Tr>
                </TBody>
            </Table>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        filtro: state.diagnosticoEnergia.filtro,
        situacaoAtual: state.diagnosticoEnergia.situacaoAtual,
        listaTipoAnalise: state.diagnosticoEnergia.listaTipoAnalise,
        tarifasAneelSimulacao: state.diagnosticoEnergia.tarifasAneelSimulacao,
        listaSubgrupoFaturamento: state.cliente.listaSubgrupoFaturamento,
        listaModalidadeTarifaria: state.cliente.listaModalidadeTarifaria,
    };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            buscarTarifasSimulacaoOptante,
            setTarifasSimulacaoAneel,
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(RenderizarAnaliseOpcaoTarifariaOptanteAB);
